import LeadStatusModule from "./LeadStatusModule";
import reducer from "./redux/leadStatusReducer";
import saga from "./redux/leadStatusSagas";

export default {
  Component: LeadStatusModule,
  moduleName: "leadStatus",
  saga: saga(),
  reducer: reducer
};
